<template>
	<div id="eventlist" style="height:800px;width: 100%;position: relative;background-color: #F3F3F5;">
		<div style="height: 56px;width: 100%;" class="middle-row center">
			<h2 style="width: 50%;">事件列表</h2>
			<div class="input-group middle-row" style="margin: 5px;width: 30%;">
				<input type="text" id="start" class="form-control" placeholder="请选择时间段">
			</div>
			<button class="btn btn-success" @click="pageableTime">查询</button>
		</div>
		<div style="position: absolute;top: 56px;width: 100%;bottom: 65px;background-color: white;padding: 10px;overflow-y: scroll;">
			<table style="width: 100%;padding: 10px;margin-bottom: 0px;" class="table table-condensed">
				<thead>
					<tr>
						<th v-for="(th,i) in tableList" :key="i">{{th}}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(ev,i) in events" :key="i">
						<td>{{i+1}}</td>
						<td>{{ev.eventName}}</td>
						<td>{{ev.merchantName}}</td>
						<td>{{ev.street}}</td>
						<td>{{ev.time}}</td>
						<td>
							<div v-for="i in ev.count" :key="i">{{Object.keys(ev.values[i-1])[0]}}</div>
						</td>
						<td>
							<div style="color: red;font-weight: bold;" v-for="i in ev.count" :key="i">{{Object.values(ev.values[i-1])[0]}}</div>
						</td>
						<td>
							<div style="color: green;font-weight: bold;" v-for="i in ev.count" :key="i">{{Object.values(ev.standards[i-1])[0]}}</div>
						</td>
						<td>
							<b v-if="ev.state" style="color: green;">已处理</b>
							<b v-if="!ev.state" style="color: red;">未处理</b>
						</td>
						<td>
							<span v-if="ev.state">{{ev.processedTime}}</span>
							<b v-if="!ev.state">---</b>
						</td>
						<td>
							<button v-if="ev.state" @click="getEve(i)" class='btn btn-primary btn-sm' data-target="#detailModal" data-toggle="modal">查看</button>
							<b v-if="!ev.state">---</b>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div style="position: absolute;height: 56px;width: 100%;background-color: yellow;bottom: 0px;height: 65px;">
			<div class="middle-row center" style="height:100%;width: 100%;background-color: #EFEFEF;">
				<ul class="pagination pagination" v-if="pagetotal<=5">
					<li><a href="#" @click="tofirst">首页</a></li>
					<li><a href="#" @click="laquo">&laquo;</a></li>
					<li v-for="n in pagetotal" :key="n"><a href="#" @click="pageClick(n)">{{n}}</a></li>
					<li><a href="#" @click="raquo">&raquo;</a></li>
					<li><a href="#" @click="tolast">尾页</a></li>
				</ul>
				<ul class="pagination pagination" v-if="pagetotal>=6">
					<li><a href="#" @click="tofirst">首页</a></li>
					<li><a href="#" @click="laquo">&laquo;</a></li>
					<li><a href="#" @click="pageClick(1)">1</a></li>
					<li><a href="#" @click="pageClick(2)">2</a></li>
					<li><a href="#">...</a></li>
					<li><a href="#" @click="pageClick(pagetotal-1)">{{pagetotal-1}}</a></li>
					<li><a href="#" @click="pageClick(pagetotal)">{{pagetotal}}</a></li>
					<li><a href="#" @click="raquo">&raquo;</a></li>
					<li><a href="#" @click="tolast">尾页</a></li>
				</ul>
				<span style="margin-left: 10px;">共<b>{{pagetotal}}</b>页，当前第<b>{{pageindex+1}}</b>页，转跳至第<input type="text" v-model="topage"
					 @keydown.enter="skipto" style="margin: 5px;text-align: center;" size="1" /> 页</span>&nbsp;&nbsp;&nbsp;
				<button class="btn btn-primary" @click="toExcel">导出excel</button>&nbsp;&nbsp;&nbsp;
				<button class="btn btn-warning" @click="toExcel2">导出本页数据</button>&nbsp;&nbsp;&nbsp;
				<button class="btn btn-success" @click="toExcel3">导出时间段数据</button>
			</div>
		</div>
		<div class="modal fade" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
			<div class="modal-dialog middle-row center" style="height: 100%;width: 100%;margin: 0px;">
				<div class="modal-content" style="height:40%;width: 60%;">
					<div class="modal-header">
						<button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
						<h4 class="modal-title" id="myModalLabel">事件处理记录</h4>
					</div>
					<div class="modal-body" style="position: absolute;top: 56px;bottom:65px;width: 100%;padding: 0px 15px;">
						<div style="width: 100%;height: 100%;" class="middle-column start">
							<div class="input-group">
								<span class="input-group-addon">事件处理过程</span>
								<textarea style="font-size: 20px;" v-model="eve.detail" cols="30" rows="7" class="form-control" /></textarea>
							</div>
						</div>
					</div>
					<div class="modal-footer" style="position: absolute;bottom: 0px;width: 100%;">
						<button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
					</div>
				</div><!-- /.modal-content -->
			</div><!-- /.modal -->
		</div>
	</div>
</template>

<script>
	import {
		util
	} from '../../static/util.js'
	export default ({
		data() {
			return {
				tableList: ['序号', '事件类型', '所属企业', '所属街道', '时间', '超标内容', '超标值', '标准值', '是否处理', '处理时间', '处理详情'],
				events: [],
				eve: '',
				pagetotal: 0,
				pageindex: 0,
				eventtotal: 0,
				topage: 1,
				pagesize: 20,
				excels: [],
				excelList: ['设备编号', '事件类型', '所属企业', '所属街道', '时间', '超标内容', '超标值', '标准值', '处理时间', '处理详情'],
				start: '',
				end: ''
			}
		},
		methods: {
			toExcel: function() {
				this.$http.get(this.GLOBAL.base + "getAllEvent").then(function(msg) {
					this.excels = msg.body
					for (let eve of this.excels) {
						eve.time = util.timeToStringWithMonth(eve.time);
						if (eve.processedTime != 0) {
							eve.processedTime = util.timeToStringWithMonth(eve.processedTime);
						} else {
							eve.processedTime = '尚未处理'
						}
						eve.cbnr = [];
						eve.cbz = [];
						eve.bzz = []
						for (var i = 0; i < eve.count; i++) {
							eve.cbnr.push(Object.keys(eve.values[i])[0]);
							eve.cbz.push(Object.values(eve.values[i])[0]);
							eve.bzz.push(Object.values(eve.standards[i])[0]);
						}
						delete eve['id'];
					}
					var option = {};
					option.fileName = '超标事件列表';
					option.datas = [{
						sheetData: this.excels,
						sheetName: '超标事件列表',
						sheetHeader: this.excelList,
						sheetFilter: ['equId', 'eventName', 'merchantName', 'street', 'time', 'cbnr', 'cbz', 'bzz', 'processedTime','detail']
					}];
					var toExcel = new ExportJsonExcel(option);
					toExcel.saveExcel();
				})
			},
			toExcel2: function() {
				for (let eve of this.events) {
					eve.cbnr = [];
					eve.cbz = [];
					eve.bzz = []
					for (var i = 0; i < eve.count; i++) {
						eve.cbnr.push(Object.keys(eve.values[i])[0]);
						eve.cbz.push(Object.values(eve.values[i])[0]);
						eve.bzz.push(Object.values(eve.standards[i])[0]);
					}
					delete eve['id'];
				}
				var option = {};
				option.fileName = '超标事件列表';
				option.datas = [{
					sheetData: this.events,
					sheetName: '超标事件列表',
					sheetHeader: this.excelList,
					sheetFilter: ['equId', 'eventName', 'merchantName', 'street',  'time', 'cbnr', 'cbz', 'bzz', 'processedTime', 'detail']
				}];
				var toExcel = new ExportJsonExcel(option);
				toExcel.saveExcel();
			},
			toExcel3: function() {
				var list = [];
				if (this.start == '' || this.end == "") {
					alert('请选择时间段');
					return;
				}
				this.$http.get(this.GLOBAL.base + 'getEventTimeAble', {
					params: {
						start: this.start,
						end: this.end
					}
				}).then(function(res) {
					list = res.body;
					for (let eve of list) {
						eve.cbnr = [];
						eve.cbz = [];
						eve.bzz = []
						for (var i = 0; i < eve.count; i++) {
							eve.cbnr.push(Object.keys(eve.values[i])[0]);
							eve.cbz.push(Object.values(eve.values[i])[0]);
							eve.bzz.push(Object.values(eve.standards[i])[0]);
						}
						eve.time = util.timeToStringWithYear(eve.time);
						eve.processedTime = util.timeToStringWithYear(eve.processedTime);
						delete eve['id'];
					}
					var option = {};
					option.fileName = '超标事件列表';
					option.datas = [{
						sheetData: list,
						sheetName: '超标事件列表',
						sheetHeader: this.excelList,
						sheetFilter: ['equId', 'eventName', 'merchantName', 'street', 'time', 'cbnr', 'cbz', 'bzz', 'processedTime', 'detail']
					}];
					var toExcel = new ExportJsonExcel(option);
					toExcel.saveExcel();
				})
			},
			getAllEvent: function() {

			},
			getEve: function(i) {
				this.eve = this.events[i];
			},
			pageClick: function(n) {
				this.topage = n;
				this.skipto();
			},
			skipto: function() { //跳转至指定页面
				var numReg = /^[0-9]*$/
				var numRe = new RegExp(numReg)
				if (!numRe.test(this.topage)) {
					alert('请输入正确的数字');
					return;
				}
				if (this.topage < 0 || this.topage > this.pagetotal) {
					alert("请输入正确的页码范围");
					return;
				}
				if (this.topage == this.pageindex + 1) {
					return;
				}
				this.pageindex = this.topage - 1;
				if (!this.start || !this.end) {
					this.pageable();
				} else {
					this.pageableTime();
				}
			},
			laquo: function() {
				if (this.pageindex == 0) {
					return
				} else {
					this.pageindex--;
					if (!this.start || !this.end) {
						this.pageable();
					} else {
						this.pageableTime();
					}
				}
			},
			raquo: function() {
				if (this.pageindex > this.pagetotal - 1) {
					return
				} else {
					this.pageindex++;
					if (!this.start || !this.end) {
						this.pageable();
					} else {
						this.pageableTime();
					}
				}
			},
			pageable: function() {
				this.$http.get(this.GLOBAL.base + 'getAllEventPageable', {
					params: {
						pageindex: this.pageindex,
						pagesize: this.pagesize
					}
				}).then(function(msg) {
					this.events = msg.body;
					for (let eve of this.events) {
						eve.time = util.timeToStringWithYear(eve.time);
						eve.processedTime = util.timeToStringWithYear(eve.processedTime);
					}
					this.getCount();
				})
			},
			pageableTime: function() {
				if (!this.start || !this.end) {
					alert('请选择时间段')
				} else {
					this.$http.get(this.GLOBAL.base + 'queryEventLimited', {
						params: {
							start: this.start,
							end: this.end,
							pageindex: this.pageindex,
							pagesize: this.pagesize
						}
					}).then(function(msg) {
						this.events = msg.body.events;
						for (let eve of this.events) {
							eve.time = util.timeToStringWithYear(eve.time);
							eve.processedTime = util.timeToStringWithYear(eve.processedTime);
						}
						this.eventtotal = msg.body.limit;
						var i = this.eventtotal / 20;
						if (i % 1 == 0) {
							this.pagetotal = i;
						} else {
							this.pagetotal = Math.ceil(i);
						}
						this.topage = 1;
					})
				}
			},
			tofirst: function() {
				if (this.pageindex == 0) {
					return;
				}
				this.pageindex = 0;
				if (!this.start || !this.end) {
					this.pageable();
				} else {
					this.pageableTime();
				}
			},
			tolast: function() {
				if (this.pageindex == this.pagetotal) {
					return;
				}
				this.pageindex = this.pagetotal - 1;
				if (!this.start || !this.end) {
					this.pageable();
				} else {
					this.pageableTime();
				}
			},
			getCount: function() {
				this.$http.get(this.GLOBAL.base + 'getEventCount').then(function(msg) {
					this.eventtotal = msg.body;
					var i = this.eventtotal / 20;
					if (i % 1 == 0) {
						this.pagetotal = i;
					} else {
						this.pagetotal = Math.ceil(i);
					}
				})
			},
		},
		mounted() {
			this.pageable();
			var that = this;
			laydate.render({
				elem: '#start', //指定元素.
				type: 'datetime',
				range: true,
				format: 'yyyy-MM-dd HH:mm:ss',
				done: function(value, startData, endData) {
					var start = startData.year + '-' + startData.month + '-' + startData.date + ' ' + startData.hours + ':' +
						startData.minutes + ':' + startData.seconds;
					var end = endData.year + '-' + endData.month + '-' + endData.date + ' ' + endData.hours + ':' + endData.minutes +
						':' + endData.seconds;
					that.start = new Date(start).valueOf();
					that.end = new Date(end).valueOf();
					that.title = '时间段查询';
					that.topage = 1;
					that.pageindex = 0;
				}
			});
		}
	})
</script>

<style>
</style>
